import Notification from '@anwb/poncho/components/notification';
import styled, { css } from 'styled-components';

export const NotificationStyles = () => css`
	position: sticky;
	top: 0;
	z-index: 100;
`;

export const StyledNotification = styled(Notification)`
	${NotificationStyles}
`;
